import { Box } from '@wix/design-system';
import { ArrowRightSmall, ChevronDownSmall, ChevronUpSmall } from '@wix/wix-ui-icons-common';
import React, { useMemo } from 'react';
export const ArrowIcon = /*#__PURE__*/React.memo(_ref => {
  let {
    variant,
    isExpanded,
    disabled = false
  } = _ref;
  const arrowIcon = useMemo(() => {
    if (variant === 'button') {
      return /*#__PURE__*/React.createElement(ArrowRightSmall, null);
    }
    if (variant === 'collapsible') {
      return isExpanded ? /*#__PURE__*/React.createElement(ChevronUpSmall, null) : /*#__PURE__*/React.createElement(ChevronDownSmall, null);
    }
    return null;
  }, [variant, isExpanded]);
  return /*#__PURE__*/React.createElement(Box, {
    color: disabled ? 'D50' : undefined,
    height: "100%",
    verticalAlign: "middle"
  }, arrowIcon);
});
//# sourceMappingURL=arrow-icon.js.map